import { render } from "./FkList.vue?vue&type=template&id=b9214ff4"
import script from "./FkList.vue?vue&type=script&lang=js"
export * from "./FkList.vue?vue&type=script&lang=js"

import "./FkList.vue?vue&type=style&index=0&id=b9214ff4&lang=css"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__